<!--
 * @Author: Junjie
 * @Date: 2022-07-18 16:52:17
 * @LastEditTime: 2023-01-15 11:32:42
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/maintenance/overhaul/modules/YwDailyOverhaulTaskExecuteModal.vue
-->
<template>
  <j-modal
    :maskClosable="false"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="1200"
    @cancel="handleCancel"
    @ok="handleOk"
    class="overhaul-task-dialog"
    switchFullscreen
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <!-- 主表单区域 -->
        <a-form-model
          :disabled="disableSubmit"
          :model="model"
          :rules="validatorRules"
          @keyup.enter.native="submitForm"
          ref="form"
          slot="detail"
        >
          <a-row>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务日期" prop="taskDate">
                <j-date disabled placeholder="请选择任务日期" style="width: 100%" v-model="model.taskDate" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" prop="manager">
                <j-dict-select-tag
                  :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                  disabled
                  placeholder="请选择负责人"
                  type="list"
                  v-model="model.manager"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内部执行人员" prop="internalExecutor">
                <j-multi-select-tag
                  :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                  disabled
                  placeholder="内部执行人员"
                  v-model="model.internalExecutor"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="外聘执行人员" prop="externalExecutor">
                <a-input :disabled="disableSubmit" placeholder="请输入外聘执行人员" v-model="model.externalExecutor"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际完成时间" prop="finishTime">
                <j-date
                  :disabled="disableSubmit"
                  dateFormat="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择完成时间"
                  showTime
                  style="width: 100%"
                  v-model="model.finishTime"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
      <!-- 子表单区域 -->
      <a-tabs @change="handleChangeTabs" v-model="activeKey">
        <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="日常检修项目">
          <j-vxe-table
            :columns="ywDailyOverhaulItem.columns"
            :dataSource="ywDailyOverhaulItem.dataSource"
            :disabled="disableSubmit"
            :loading="ywDailyOverhaulItem.loading"
            :maxHeight="300"
            :ref="refKeys[0]"
            :rowNumber="true"
            :rowSelection="true"
            :toolbar="false"
            keep-source
          >
            <template v-slot:action="props">
              <a @click="addBpbj(props)" v-if="props.row.devId && !disableSubmit">添加</a>
            </template>
          </j-vxe-table>
        </a-tab-pane>
      </a-tabs>

      <!-- 消耗备品备件列表 -->
      <DevBpbjLeadoutRecordList :canEdit="!disableSubmit" ref="devBpbjLeadoutRecordList"></DevBpbjLeadoutRecordList>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleOk" type="primary" v-if="!disableSubmit">保存</a-button>
      <a-button @click="handleFinish" type="primary" v-if="!disableSubmit">完结</a-button>
      <a-button @click="handleCancel">关闭</a-button>
    </template>
    <!-- 选择备品备件list -->
    <DevBpbjInfoList :title="deviceName" @refresList="refresList" ref="DevBpbjInfoList" taskTable="overhaul"></DevBpbjInfoList>
  </j-modal>
</template>

<script>
  import { JVxeTableModelMixin } from '@/mixins/JVxeTableModelMixin.js'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { getRefPromise, VALIDATE_FAILED } from '@/components/jeecg/JVxeTable/utils/vxeUtils.js'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import DevBpbjInfoList from '@/views/eMaintenance/modules/DevBpbjInfoList'
  import DevBpbjLeadoutRecordList from '@/views/eMaintenance/modules/DevBpbjLeadoutRecordList'
  import moment from "dayjs";
  import { httpAction } from '@/api/manage'
  import { omit } from 'lodash'


  export default {
    name: 'YwDailyOverhaulTaskExecuteModal',
    mixins: [JVxeTableModelMixin],
    components: {
      JFormContainer,
      DevBpbjInfoList,
      DevBpbjLeadoutRecordList
    },
    data () {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        canEdit: true,
        deviceName: '',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        model: {

        },

        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          taskDate: [
            { required: true, message: '请输入任务日期!' },
          ],
          manager: [
            { required: true, message: '请输入负责人!' },
          ],
          finishTime: [
            { required: true, message: '请输入完成时间!' },
          ],
          //   finishPerson: [
          //     { required: true, message: '请输入实际完成人!' },
          //   ],
        },
        refKeys: ['ywDailyOverhaulItem',],
        tableKeys: ['ywDailyOverhaulItem',],
        activeKey: 'ywDailyOverhaulItem',
        // 日常检修项目
        ywDailyOverhaulItem: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '供水流域',
              key: 'devProcessId',
              type: JVXETypes.select,
              options: [],
              dictCode: "`iwt-wf`.dev_process,process_name,id",
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              disabled: true,
            },
            {
              title: '设备',
              key: 'devId',
              type: JVXETypes.select,
              options: [],
              dictCode: "`iwt-wf`.dev_list,dev_name,id,del_flag=0 order by sort asc",
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              disabled: true,
            },
            {
              title: '工作内容',
              key: 'workContent',
              type: JVXETypes.textarea,
              width: "400px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: '是否完成',
              key: 'isExecute',
              type: JVXETypes.checkbox,
              width: "120px",
              customValue: ['Y', 'N'], // true ,false
              align: 'center',
              defaultValue: false,
            },
            {
              title: '备件消耗',
              key: 'action',
              type: JVXETypes.slot,
              width: "120px",
              align: 'center',
              slotName: 'action',
            },
          ]
        },
        url: {
          add: "/maintenance/overhaul/add",
          edit: "/maintenance/overhaul/edit",
          finish: "/maintenance/overhaul/finish",
          queryById: "/maintenance/overhaul/queryById",
          ywDailyOverhaulItem: {
            list: '/maintenance/overhaul/queryYwDailyOverhaulItemByMainId'
          },
        }
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },

    },
    methods: {
      addBpbj (props) {
        const row = props.row;
        this.deviceName = row?.devName ? `${row?.devName}：消耗备件` : '消耗备件'
        this.$refs.DevBpbjInfoList.open(row)
      },
      // 刷新已消耗的备品备件list
      refresList (list) {
        const recordList = this.$refs.devBpbjLeadoutRecordList.dataSource
        this.$refs.devBpbjLeadoutRecordList.dataSource = recordList.concat(list)
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.devBpbjLeadoutRecordList.getData(record.id)
          if (typeof this.editBefore === 'function') this.editBefore(record)
          this.visible = true
          this.activeKey = this.refKeys[0]
          this.$refs.form.resetFields();

          this.model = Object.assign({}, record);
          //如果是已完结，不能赋值；如果本身有值，也不赋值
          if (!this.disableSubmit) {
            this.model.finishTime = this.model.finishTime || moment().format('YYYY-MM-DD HH:mm:ss');
            this.model.finishPerson = this.model.finishPerson || this.$store.getters.userInfo.id;
          }
          if (typeof this.editAfter === 'function') this.editAfter(this.model)
        })
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            let httpurl = this.url.edit;
            let method = 'put';
            const tableData = this.$refs[this.refKeys[0]].getTableData();

            // 整理成formData
            let formData = {
              ...this.model,
              ywDailyOverhaulItemList: tableData,
              bpbjLeadoutList: this.$refs.devBpbjLeadoutRecordList.dataSource.map(map => {
                map.bjModelId = map.id;
                omit(map, ['id']);
                return map;
              })
            };
            delete formData.finishTime;

            that.confirmLoading = true;

            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              this.submitCallback();
            });
          }

        })
      },
      handleFinish () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            let httpurl = that.url.finish;
            let method = 'put';
            const tableData = this.$refs[this.refKeys[0]].getTableData();

            const unfinished = tableData.find(item => item.isExecute != 'Y');
            if (unfinished) {
              that.$message.warning('所有项目完成才能完结任务！');
              return;
            }
            // 整理成formData
            let formData = Object.assign(that.model, {
              taskStatus: 1,
              finishPerson: that.model.manager,
              ywDailyOverhaulItemList: tableData,
              bpbjLeadoutList: that.$refs.devBpbjLeadoutRecordList.dataSource.map(map => {
                map.bjModelId = map.id;
                omit(map, ['id']);
                return map;
              })
            });

            that.confirmLoading = true;

            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.submitCallback();
            });
          }

        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      addBefore () {
        this.ywDailyOverhaulItem.dataSource = []
      },
      getAllTable () {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter () {
        this.$nextTick(() => {
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.ywDailyOverhaulItem.list, params, this.ywDailyOverhaulItem)
        }
      },
      //校验所有一对一子表表单
      validateSubForm (allValues) {
        return new Promise((resolve, reject) => {
          Promise.all([
          ]).then(() => {
            resolve(allValues)
          }).catch(e => {
            if (e.error === VALIDATE_FAILED) {
              // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
              this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
            } else {
              console.error(e)
            }
          })
        })
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          ywDailyOverhaulItemList: allValues.tablesValue[0].tableData,
          bpbjLeadoutList: this.$refs.devBpbjLeadoutRecordList.dataSource
        }
      },
      validateError (msg) {
        this.$message.error(msg)
      },
    }
  }
</script>

<style lang="less" scoped>
  .overhaul-task-dialog {
    /deep/ .ant-card-body {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>